// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../statics/ai_assistant_butn.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../../statics/modal_image_close.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../../statics/thinking_square.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../../statics/thinking_square_hover.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../../../statics/thinking_square_active.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AIAssistantButn_main__nBK26 {
    position: relative;
}

.AIAssistantButn_butn_box__mGJOv {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 121px;
    height: 56px;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center / 100% 100%;
    cursor: pointer;
}

.AIAssistantButn_chat_box__i5kfP {
    position: absolute;
    top: -420px;
    left: -120px;
    width: 240px;
    height: 400px;
}

.AIAssistantButn_ai_main__m49TJ {
    width: 100%;
    height: 100%;
    border-radius: 12px;
    background-color: #f6fafb;
    box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.15);
}

.AIAssistantButn_ai_header_box__PXyI9 {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 55px;
    padding: 0 8px;
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
    background-color: #fff;
}

.AIAssistantButn_ai_content_box__P6jse {
    width: 100%;
    height: calc(100% - 55px - 58px);
}

.AIAssistantButn_ai_input_box__Dtawr {
    width: 100%;
    height: 58px;
    border-bottom-left-radius: 12px;
    border-bottom-right-radius: 12px;
    background-color: #fff;
}

.AIAssistantButn_ai_header_online__QQ05F {
    width: 40px;
    height: 40px;
}

.AIAssistantButn_ai_header_text_box__S5Za0 {
    width: 130px;
    height: 40px;
}

.AIAssistantButn_ai_header_title__ougbd {
    font-family: 'PingFangSCMedium';
    font-weight: bold;
    font-size: 14px;
    color: #101417;
    line-height: 20px;
}

.AIAssistantButn_ai_header_status__-REJD {
    font-family: "PingFangSCRegular";
    color: #414648;
    font-size: 12px;
    line-height: 20px;
}

.AIAssistantButn_ai_header_close_box__UxBP2 {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 30px;
    height: 30px;
    border-radius: 6px;
    cursor: pointer;
}

.AIAssistantButn_ai_header_close_box__UxBP2:hover {
    background-color: #f0f0f0;
}

.AIAssistantButn_ai_header_close_box__UxBP2:active {
    background-color: #d9d9d9;
}

.AIAssistantButn_ai_header_close__gd8NH {
    width: 15px;
    height: 15px;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat center / 100% 100%;
}

.AIAssistantButn_textarea_box__idneO {
    position: relative;
    width: 100%;
    height: 58px;
}

.AIAssistantButn_custom_textarea__C4ZZc {
    height: 58px;
    min-height: 58px !important;
    max-height: 58px !important;
    padding: 10px 35px 10px 10px;
    font-size: 14px;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    border-color: #fff;
}

.AIAssistantButn_custom_textarea__C4ZZc::placeholder {
    /* padding-top: 10px; */
}

.AIAssistantButn_custom_textarea__C4ZZc:hover,
.AIAssistantButn_custom_textarea__C4ZZc:focus-within,
.AIAssistantButn_custom_textarea__C4ZZc:focus {
    border-color: #17a8b5;
}

/* 自定义滚动条 */
.AIAssistantButn_custom_textarea__C4ZZc::-webkit-scrollbar {/*滚动条整体样式*/
    -webkit-appearance: none;
    width: 5px;
    height: 5px;
}

.AIAssistantButn_custom_textarea__C4ZZc::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
    cursor: pointer;
    border-radius: 5px;
    background: #e9e9e9;
    -webkit-transition: color .2s ease;
    transition: color .2s ease;
}

.AIAssistantButn_custom_textarea__C4ZZc::-webkit-scrollbar-thumb:hover {
    background: #e3e3e3;
    cursor: default;
}

.AIAssistantButn_send_butn_img__JPbJc {
    position: absolute;
    right: 10px;
    top: 15px;
    cursor: pointer;
}

@keyframes AIAssistantButn_spin__BMvav {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}

.AIAssistantButn_thinking_loading_box__Uen4L {
    width: 32px;
    height: 32px;
    position: absolute;
    right: 9px;
    top: 9px;
    cursor: pointer;
    border-radius: 100%;
    -webkit-user-select: none;
            user-select: none;
}

.AIAssistantButn_circle_img__VApcY {
    width: 32px;
    height: 32px;
    position: absolute;
    right: 0px;
    top: 0px;
    animation: AIAssistantButn_spin__BMvav 2s linear infinite;
}

.AIAssistantButn_square_img__Sqjhh {
    width: 12px;
    height: 12px;
    position: absolute;
    right: 10px;
    top: 10px;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat center / 100% 100%;
    transition: background 0.5s, box-shadow 0.5s;
}


/* 隐藏伪元素用来预加载悬停背景图 */
.AIAssistantButn_thinking_loading_box__Uen4L::before .AIAssistantButn_square_img__Sqjhh {
    content: "";
    background: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) no-repeat center / 100% 100%;
    position: absolute;
    width: 0;
    height: 0;
    overflow: hidden;
    z-index: -1;
}

.AIAssistantButn_thinking_loading_box__Uen4L::after .AIAssistantButn_square_img__Sqjhh {
    content: "";
    background: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) no-repeat center / 100% 100%;
    position: absolute;
    width: 0;
    height: 0;
    overflow: hidden;
    z-index: -1;
}

.AIAssistantButn_thinking_loading_box__Uen4L:hover .AIAssistantButn_square_img__Sqjhh {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) no-repeat center / 100% 100%;
}

.AIAssistantButn_thinking_loading_box__Uen4L:active .AIAssistantButn_square_img__Sqjhh {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) no-repeat center / 100% 100%;
}

.AIAssistantButn_message_none_box__dvr32 {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    padding: 15px;
}

.AIAssistantButn_message_none_title__BxB8b {
    font-size: 10px;
    color: #414648;
    margin-bottom: 8px;
}

.AIAssistantButn_message_none_list__e05tf {
    width: 100%;
}

.AIAssistantButn_message_none_butn__fru2Z {
    width: 100%;
    height: 28px;
    border: 1px solid #17A8B5;
    margin-bottom: 8px;
    text-align: center;
    line-height: 28px;
    font-size: 12px;
    color: #17A8B5;
    background-color: #ffffff;
    border-radius: 28px;
    cursor: pointer;
    transition: background-color 0.5s, color 0.5s;
    -webkit-user-select: none;
            user-select: none;
}

.AIAssistantButn_message_none_butn__fru2Z:hover {
    background-color: #e4f0f2;
}

.AIAssistantButn_message_none_butn__fru2Z:active {
    color: #fff;
    background-color: #74bdc6;
}

.AIAssistantButn_ai_content_list_box__YwNm5 {
    width: 100%;
    height: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/pages/home/components/AIAssistantButn/index.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,gFAAyF;IACzF,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,4CAA4C;AAChD;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,cAAc;IACd,4BAA4B;IAC5B,6BAA6B;IAC7B,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,+BAA+B;IAC/B,gCAAgC;IAChC,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,+BAA+B;IAC/B,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,gCAAgC;IAChC,cAAc;IACd,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gFAAyF;AAC7F;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,2BAA2B;IAC3B,2BAA2B;IAC3B,4BAA4B;IAC5B,eAAe;IACf,yBAAyB;IACzB,0BAA0B;IAC1B,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;;;IAGI,qBAAqB;AACzB;;AAEA,WAAW;AACX,4DAAqC,UAAU;IAC3C,wBAAwB;IACxB,UAAU;IACV,WAAW;AACf;;AAEA,kEAA2C,WAAW;IAClD,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IAEnB,kCAA0B;IAA1B,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,eAAe;AACnB;;AAEA;IACI;QACI,uBAAuB;IAC3B;IACA;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,eAAe;IACf,mBAAmB;IACnB,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,yDAAkC;AACtC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,gFAAuF;IACvF,4CAA4C;AAChD;;;AAGA,oBAAoB;AACpB;IACI,WAAW;IACX,gFAA6F;IAC7F,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,gFAA8F;IAC9F,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,gFAA6F;AACjG;;AAEA;IACI,gFAA8F;AAClG;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,6CAA6C;IAC7C,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;AAChB","sourcesContent":[".main {\n    position: relative;\n}\n\n.butn_box {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 121px;\n    height: 56px;\n    background: url('../../../../statics/ai_assistant_butn.png') no-repeat center / 100% 100%;\n    cursor: pointer;\n}\n\n.chat_box {\n    position: absolute;\n    top: -420px;\n    left: -120px;\n    width: 240px;\n    height: 400px;\n}\n\n.ai_main {\n    width: 100%;\n    height: 100%;\n    border-radius: 12px;\n    background-color: #f6fafb;\n    box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.15);\n}\n\n.ai_header_box {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    height: 55px;\n    padding: 0 8px;\n    border-top-left-radius: 12px;\n    border-top-right-radius: 12px;\n    background-color: #fff;\n}\n\n.ai_content_box {\n    width: 100%;\n    height: calc(100% - 55px - 58px);\n}\n\n.ai_input_box {\n    width: 100%;\n    height: 58px;\n    border-bottom-left-radius: 12px;\n    border-bottom-right-radius: 12px;\n    background-color: #fff;\n}\n\n.ai_header_online {\n    width: 40px;\n    height: 40px;\n}\n\n.ai_header_text_box {\n    width: 130px;\n    height: 40px;\n}\n\n.ai_header_title {\n    font-family: 'PingFangSCMedium';\n    font-weight: bold;\n    font-size: 14px;\n    color: #101417;\n    line-height: 20px;\n}\n\n.ai_header_status {\n    font-family: \"PingFangSCRegular\";\n    color: #414648;\n    font-size: 12px;\n    line-height: 20px;\n}\n\n.ai_header_close_box {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 30px;\n    height: 30px;\n    border-radius: 6px;\n    cursor: pointer;\n}\n\n.ai_header_close_box:hover {\n    background-color: #f0f0f0;\n}\n\n.ai_header_close_box:active {\n    background-color: #d9d9d9;\n}\n\n.ai_header_close {\n    width: 15px;\n    height: 15px;\n    background: url('../../../../statics/modal_image_close.png') no-repeat center / 100% 100%;\n}\n\n.textarea_box {\n    position: relative;\n    width: 100%;\n    height: 58px;\n}\n\n.custom_textarea {\n    height: 58px;\n    min-height: 58px !important;\n    max-height: 58px !important;\n    padding: 10px 35px 10px 10px;\n    font-size: 14px;\n    border-top-left-radius: 0;\n    border-top-right-radius: 0;\n    border-color: #fff;\n}\n\n.custom_textarea::placeholder {\n    /* padding-top: 10px; */\n}\n\n.custom_textarea:hover,\n.custom_textarea:focus-within,\n.custom_textarea:focus {\n    border-color: #17a8b5;\n}\n\n/* 自定义滚动条 */\n.custom_textarea::-webkit-scrollbar {/*滚动条整体样式*/\n    -webkit-appearance: none;\n    width: 5px;\n    height: 5px;\n}\n\n.custom_textarea::-webkit-scrollbar-thumb {/*滚动条里面小方块*/\n    cursor: pointer;\n    border-radius: 5px;\n    background: #e9e9e9;\n    -webkit-transition: color .2s ease;\n    transition: color .2s ease;\n}\n\n.custom_textarea::-webkit-scrollbar-thumb:hover {\n    background: #e3e3e3;\n    cursor: default;\n}\n\n.send_butn_img {\n    position: absolute;\n    right: 10px;\n    top: 15px;\n    cursor: pointer;\n}\n\n@keyframes spin {\n    from {\n        transform: rotate(0deg);\n    }\n    to {\n        transform: rotate(360deg);\n    }\n}\n\n.thinking_loading_box {\n    width: 32px;\n    height: 32px;\n    position: absolute;\n    right: 9px;\n    top: 9px;\n    cursor: pointer;\n    border-radius: 100%;\n    user-select: none;\n}\n\n.circle_img {\n    width: 32px;\n    height: 32px;\n    position: absolute;\n    right: 0px;\n    top: 0px;\n    animation: spin 2s linear infinite;\n}\n\n.square_img {\n    width: 12px;\n    height: 12px;\n    position: absolute;\n    right: 10px;\n    top: 10px;\n    background: url('../../../../statics/thinking_square.png') no-repeat center / 100% 100%;\n    transition: background 0.5s, box-shadow 0.5s;\n}\n\n\n/* 隐藏伪元素用来预加载悬停背景图 */\n.thinking_loading_box::before .square_img {\n    content: \"\";\n    background: url('../../../../statics/thinking_square_hover.png') no-repeat center / 100% 100%;\n    position: absolute;\n    width: 0;\n    height: 0;\n    overflow: hidden;\n    z-index: -1;\n}\n\n.thinking_loading_box::after .square_img {\n    content: \"\";\n    background: url('../../../../statics/thinking_square_active.png') no-repeat center / 100% 100%;\n    position: absolute;\n    width: 0;\n    height: 0;\n    overflow: hidden;\n    z-index: -1;\n}\n\n.thinking_loading_box:hover .square_img {\n    background: url('../../../../statics/thinking_square_hover.png') no-repeat center / 100% 100%;\n}\n\n.thinking_loading_box:active .square_img {\n    background: url('../../../../statics/thinking_square_active.png') no-repeat center / 100% 100%;\n}\n\n.message_none_box {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 100%;\n    padding: 15px;\n}\n\n.message_none_title {\n    font-size: 10px;\n    color: #414648;\n    margin-bottom: 8px;\n}\n\n.message_none_list {\n    width: 100%;\n}\n\n.message_none_butn {\n    width: 100%;\n    height: 28px;\n    border: 1px solid #17A8B5;\n    margin-bottom: 8px;\n    text-align: center;\n    line-height: 28px;\n    font-size: 12px;\n    color: #17A8B5;\n    background-color: #ffffff;\n    border-radius: 28px;\n    cursor: pointer;\n    transition: background-color 0.5s, color 0.5s;\n    user-select: none;\n}\n\n.message_none_butn:hover {\n    background-color: #e4f0f2;\n}\n\n.message_none_butn:active {\n    color: #fff;\n    background-color: #74bdc6;\n}\n\n.ai_content_list_box {\n    width: 100%;\n    height: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `AIAssistantButn_main__nBK26`,
	"butn_box": `AIAssistantButn_butn_box__mGJOv`,
	"chat_box": `AIAssistantButn_chat_box__i5kfP`,
	"ai_main": `AIAssistantButn_ai_main__m49TJ`,
	"ai_header_box": `AIAssistantButn_ai_header_box__PXyI9`,
	"ai_content_box": `AIAssistantButn_ai_content_box__P6jse`,
	"ai_input_box": `AIAssistantButn_ai_input_box__Dtawr`,
	"ai_header_online": `AIAssistantButn_ai_header_online__QQ05F`,
	"ai_header_text_box": `AIAssistantButn_ai_header_text_box__S5Za0`,
	"ai_header_title": `AIAssistantButn_ai_header_title__ougbd`,
	"ai_header_status": `AIAssistantButn_ai_header_status__-REJD`,
	"ai_header_close_box": `AIAssistantButn_ai_header_close_box__UxBP2`,
	"ai_header_close": `AIAssistantButn_ai_header_close__gd8NH`,
	"textarea_box": `AIAssistantButn_textarea_box__idneO`,
	"custom_textarea": `AIAssistantButn_custom_textarea__C4ZZc`,
	"send_butn_img": `AIAssistantButn_send_butn_img__JPbJc`,
	"thinking_loading_box": `AIAssistantButn_thinking_loading_box__Uen4L`,
	"circle_img": `AIAssistantButn_circle_img__VApcY`,
	"spin": `AIAssistantButn_spin__BMvav`,
	"square_img": `AIAssistantButn_square_img__Sqjhh`,
	"message_none_box": `AIAssistantButn_message_none_box__dvr32`,
	"message_none_title": `AIAssistantButn_message_none_title__BxB8b`,
	"message_none_list": `AIAssistantButn_message_none_list__e05tf`,
	"message_none_butn": `AIAssistantButn_message_none_butn__fru2Z`,
	"ai_content_list_box": `AIAssistantButn_ai_content_list_box__YwNm5`
};
export default ___CSS_LOADER_EXPORT___;
